import React, { useRef, useState, useEffect } from "react";
import iconCheckmark from "url:shared-assets/icons/checkmark.svg";

interface Props {
  step: number;
  stepsDone: Array<boolean>;
  changeStep: Function;
}

const ProgressCircle: React.FC<Props> = (props: Props) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [dashWidth, setDashWidth] = useState("100px");

  useEffect(() => {
    if (containerRef) {
      const w = containerRef.current ? containerRef.current.clientWidth : 500;
      if (w < 636) {
        // Space between calendar cols: width - 312 / 6, where 312 is cols with + margin and
        // 6 is nr of spaces between cols*/
        const colGap = w / (props.stepsDone.length - 1) - 24;
        setDashWidth(colGap + "px");
      }
    }
  }, [containerRef]);

  const click = (done: boolean, index: number) => {
    props.changeStep(index);
  };

  const getClass = (done: boolean, index: number) => {
    const baseClass =
      "rounded-full h-6 w-6 flex items-center justify-center cursor-pointer ";
    if (done) {
      return baseClass + "bg-success-500 text-black";
    } else if (index === props.step) {
      return baseClass + "bg-success-300 text-black";
    } else {
      return baseClass + "bg-indigo-800";
    }
  };

  const getDashClass = (done: boolean, index: number) => {
    const baseClass = "h-0.5 ";
    if (props.stepsDone[index - 1] || props.step >= index) {
      return baseClass + "bg-success-500";
    }
    return baseClass + "bg-indigo-800";
  };

  return (
    <div className="flex items-center" ref={containerRef}>
      {props.stepsDone.map((stepDone, index) => {
        return (
          <div key={"step_" + index} className="flex items-center">
            {index > 0 && (
              <div className="flex items-center">
                <div
                  className={getDashClass(stepDone, index)}
                  style={{ width: dashWidth }}
                ></div>
              </div>
            )}
            <div
              className={getClass(stepDone, index)}
              onClick={() => click(stepDone, index)}
            >
              {stepDone ? (
                index === props.step ? (
                  <>{index + 1}</>
                ) : (
                  <img src={iconCheckmark} alt="done" />
                )
              ) : (
                <>{index + 1}</>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProgressCircle;
